import { Component, inject } from '@angular/core';

import { DialogRef } from '@angular/cdk/dialog';
import { ContactUsFormComponent } from '../contact-us-form/contact-us-form.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-contact-us-dialog',
  imports: [ContactUsFormComponent, TranslateModule],
  templateUrl: './contact-us-dialog.component.html',
  styleUrls: ['./contact-us-dialog.component.scss'],
})
export class ContactUsDialogComponent {
  private dialogRef = inject<DialogRef<string>>(DialogRef);

  closeDialog() {
    this.dialogRef.close();
  }
}
